import { render, staticRenderFns } from "./accountbalances.vue?vue&type=template&id=10f69109&scoped=true"
import script from "./accountbalances.vue?vue&type=script&lang=js"
export * from "./accountbalances.vue?vue&type=script&lang=js"
import style0 from "./accountbalances.vue?vue&type=style&index=0&id=10f69109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f69109",
  null
  
)

export default component.exports